import { render, staticRenderFns } from "./BookHub.vue?vue&type=template&id=3e6eecb8&scoped=true&"
import script from "./BookHub.vue?vue&type=script&lang=js&"
export * from "./BookHub.vue?vue&type=script&lang=js&"
import style0 from "./BookHub.vue?vue&type=style&index=0&id=3e6eecb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6eecb8",
  null
  
)

export default component.exports